<template>
  <div class="detail-card-wrapper">
    <div class="detail-card-title">{{ cardTitle }}</div>
    <div class="detail-card-body">
      <div v-if="formatCardTitle" class="detail-body-cell">
        <div class="detail-card-label">{{ getEntityLabel + ' Name' }}</div>
        <div class="detail-card-data">{{ formatCardTitle }}</div>
      </div>
      <div v-if="formatInstruction" class="detail-body-cell">
        <div class="detail-card-label">Instruction</div>
        <div class="detail-card-data">{{ formatInstruction }}</div>
      </div>
      <div v-if="formatIngredients" class="detail-body-cell">
        <div class="detail-card-label">Compound (Ingredients)</div>
        <div class="detail-card-data">{{ formatIngredients }}</div>
      </div>
      <div v-if="formatProcedureOutcome" class="detail-body-cell">
        <div class="detail-card-label">Procedure Outcome</div>
        <div class="detail-card-data">{{ formatProcedureOutcome }}</div>
      </div>
      <div v-if="formatProcedureObservations" class="detail-body-cell">
        <div class="detail-card-label">Procedure Observations</div>
        <div class="detail-card-data">{{ formatProcedureObservations }}</div>
      </div>
      <div v-if="formatDoseAmount" class="detail-body-cell">
        <div class="detail-card-label">Dose amount</div>
        <div class="detail-card-data">{{ formatDoseAmount }}</div>
      </div>
      <div v-if="formatDoseUnit" class="detail-body-cell">
        <div class="detail-card-label">Dose units</div>
        <div class="detail-card-data">{{ formatDoseUnit }}</div>
      </div>
      <div v-if="formatRoute" class="detail-body-cell">
        <div class="detail-card-label">Route</div>
        <div class="detail-card-data">{{ formatRoute }}</div>
      </div>
      <div v-if="formatValues" class="detail-body-cell">
        <div class="detail-card-label">{{ getEntityLabel + 'Value' }}</div>
        <div class="detail-card-data">{{ formatValues }}</div>
      </div>
      <div v-if="formatUnits" class="detail-body-cell">
        <div class="detail-card-label">{{ getEntityLabel + 'Units' }}</div>
        <div class="detail-card-data">{{ formatUnits }}</div>
      </div>
      <div v-if="formatReferenceRange" class="detail-body-cell">
        <div class="detail-card-label">{{ getEntityLabel + 'Reference Range' }}</div>
        <div class="detail-card-data">{{ formatReferenceRange }}</div>
      </div>
      <div v-if="formatInterpretation" class="detail-body-cell">
        <div class="detail-card-label">
          {{ getEntityLabel + 'Interpretation (high or low)' }}
        </div>
        <div class="detail-card-data">{{ formatInterpretation }}</div>
      </div>
      <div v-if="formatNotes" class="detail-body-cell">
        <div class="detail-card-label">{{ getEntityLabel + 'Interpretation Notes' }}</div>
        <div class="detail-card-data">{{ formatNotes }}</div>
      </div>
      <div v-if="formatDate" class="detail-body-cell">
        <div class="detail-card-label">{{ formatDateLabel }}</div>
        <div class="detail-card-data">{{ formatDate }}</div>
      </div>
      <div v-if="formatEndDate" class="detail-body-cell">
        <div class="detail-card-label">End Date</div>
        <div class="detail-card-data">{{ formatEndDate }}</div>
      </div>
      <div v-if="formatStatus" class="detail-body-cell">
        <div class="detail-card-label">Status</div>
        <div class="detail-card-data">{{ formatStatus }}</div>
      </div>
      <div v-if="formatReactions" class="detail-body-cell">
        <div class="detail-card-label">Reactions</div>
        <div class="detail-card-data">{{ formatReactions }}</div>
      </div>
      <div v-if="formatSeverityReactions" class="detail-body-cell">
        <div class="detail-card-label">Reaction Severity</div>
        <div class="detail-card-data">{{ formatSeverityReactions }}</div>
      </div>
      <div v-if="formatPractitioner" class="detail-body-cell">
        <div class="detail-card-label">Practitioner</div>
        <div class="detail-card-data">{{ formatPractitioner }}</div>
      </div>
      <div v-if="formatTestingCompany" class="detail-body-cell">
        <div class="detail-card-label">Testing company</div>
        <div class="detail-card-data">{{ formatTestingCompany }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'
import EntityDetailCard from '../utils/entity-detail-card'

export default {
  name: 'DetailCard',
  props: {
    entity: {
      type: Object,
      default: () => {}
    },
    cardTitle: {
      type: String,
      default: ''
    },
    entityType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formatCardTitle: EntityDetailCard.formatCardTitle(this.entity, this.entityType),
      formatIngredients: EntityDetailCard.formatIngredients(this.entity),
      formatDate: EntityDetailCard.formatDate(this.entity),
      formatEndDate: EntityDetailCard.formatEndDate(this.entity, this.entityType),
      formatDateLabel: EntityDetailCard.formatDateLabel(this.entityType),
      formatPractitioner: EntityDetailCard.formatPractitioner(this.entity, this.entityType),
      formatValues: EntityDetailCard.formatValues(this.entity),
      formatNotes: EntityDetailCard.formatNotes(this.entity),
      formatReferenceRange: EntityDetailCard.formatReferenceRange(this.entity),
      formatInterpretation: EntityDetailCard.formatInterpretation(this.entity, this.entityType),
      formatUnits: EntityDetailCard.formatUnits(this.entity),
      formatReactions: EntityDetailCard.formatReactions(this.entity),
      formatSeverityReactions: EntityDetailCard.formatSeverityReactions(this.entity),
      getEntityLabel: EntityDetailCard.getEntityLabel(this.entityType),
      formatDoseAmount: get(this.entity, 'product.ingredients[0].valueUnits.value', ''),
      formatDoseUnit: get(this.entity, 'product.ingredients[0].valueUnits.unit', ''),
      formatProcedureOutcome: get(this.entity, 'outcome.codes[0].name', ''),
      formatProcedureObservations: get(this.entity, 'observations', ''),
      formatInstruction: get(this.entity, 'dosage.patientInstruction', ''),
      formatRoute: get(this.entity, 'dosage.route.coding.dispaly', ''),
      formatStatus: get(this.entity, 'clinicalStatus.coding.code', ''),
      formatTestingCompany: get(this.entity, 'performers[0].organization.name', '')
    }
  }
}
</script>

<style scoped>
.detail-card-wrapper {
  border-radius: 8px;
  margin: 24px 0;
  padding: 16px 24px;
  background: #ffffff;
  border: 1px solid #C9CBD5;
}

.detail-card-body {
  display: flex;
  flex-direction: column;
}

.detail-body-cell {
  display: flex;
  margin-bottom: 12px;
}

.detail-card-label {
  font-size: 15px;
  max-width: 180px;
  color: #4f4f4f;
  min-width: 180px;
}

.detail-card-title {
  font-size: 18px;
  margin-bottom: 12px;
  font-weight: 600;
}

.detail-card-data {
  font-size: 14px;
  margin-bottom: 5px;
  color: #52575c;
  padding: 0 10px;
}

.detail-card-instructions {
  font-size: 14px;
}
@media only screen and (max-width: 561px) {
  .detail-card-label {
    min-width: 150px;
    max-width: 150px;
  }
}
</style>
